// extracted by mini-css-extract-plugin
export default {"container":"Search_container__JDaLY","create":"Search_create__d2bMV"};